import { useViewedItems } from './useViewedItems';

export function useViewedClips() {
  return useViewedItems('arbor:viewedClipIds');
}
